import React from 'react';
import styled from 'styled-components';

import {pxToRem} from 'utils/ui/units';
import {spacing} from 'styles/globals';

import Button from 'components/Button';
import AlertBox from 'components/AlertBox';

const progressBackgroundColour = 'rgba(0, 0, 0, 0.1)';
const progressValueColour = 'currentColor';

const ProgressBar = styled.progress`
	display: block;
	width: 100%;
	min-width: ${pxToRem(180)};
	height: 5px;
	margin: ${spacing.xs} 0;
	overflow: hidden;

	border: 0;
	border-radius: rem(3px);
	background-color: ${progressBackgroundColour};

	&::-moz-progress-bar {
		background: ${progressValueColour};
	}

	&::-webkit-progress-bar {
		background: ${progressBackgroundColour};
	}

	&::-webkit-progress-value {
		background: ${progressValueColour};
	}

	&::-ms-fill {
		background: ${progressValueColour};
	}
`;

const AdvancedAlertBox = ({title, type, progress, message, cta, onClose}) => {
	const hasProgressBar = progress !== undefined && progress !== null;
	return (
		<AlertBox isVisible title={title} type={type} onClose={onClose}>
			{hasProgressBar && (
				<ProgressBar value={progress} max="100">
					{progress}
				</ProgressBar>
			)}
			{message}
			{cta && (
				<>
					{' '}
					<Button
						{...cta}
						variant="shaded"
						size="small"
						aria-hidden="true"
					>
						{cta.title}
					</Button>
				</>
			)}
		</AlertBox>
	);
};

export default AdvancedAlertBox;
